import React, { useEffect, useState, useContext } from 'react';
import './callpick.css';
import Peer from 'peerjs';
import Parse from 'parse';
import { AuthContext } from '../../auth';
import { callContext } from '../../callContext';
import { PeerjsContext } from '../../peerContext';
import { Redirect } from 'react-router-dom';

const Callcancel = (props) => {
    // useEffect (get patient id from prop)
    // Get latestpeerjsid of patient from parse based on the prop
    // trigger call function of peerjs


    const [name, setName] = useState('');
    const [peerid, setPeerid] = useState('');
    const id = props.match.params.id;
    let [logedinuser, setLogedinuser] = useContext(AuthContext);
    const peerRef = useContext(PeerjsContext);
    const callProp = useContext(callContext);

    useEffect(() => {
        const User = Parse.Object.extend("User");
        const query = new Parse.Query(User);
        console.log(id);
        query.get(id)
            .then((patient) => {
                console.log(patient.id);
                setName(patient.get("name"));
                setPeerid(patient.get("peerId"));
                console.log(peerid);
            }, (error) => {
                console.log(error);
            })

    }, [])


    const handleClose = () => {
        callProp.current.close();
        document.getElementById("seconds").innerHTML = "DEAD"
    }

    let sec = 0;
    setInterval(function () {
        document.getElementById("seconds").innerHTML = ++sec % 60 > 9 ? sec % 60 : "0" + sec % 60;
        document.getElementById("minutes").innerHTML = parseInt(sec / 60, 10) > 9 ? parseInt(sec / 60, 10) : "0" + parseInt(sec / 60, 10);
    }, 1000);

    return (

        <div className="container mt-5" style={{ fontFamily: "'Open Sans', open-serif" }}>
            {(logedinuser == null) && (
                <Redirect to="/counsellor/login" />
            )}
            <div className="row ">
                <div className="col-12 text-center">
                    <img src="/assests/images/user.png" className="rounded-circle userheight" alt=""></img>
                </div>
                <div className="col-12 text-center">
                    <p className="mt-2 docname mb-auto">{name}</p>
                </div>
                <div className="col-12" style={{ display: "contents" }}>
                    <p className="ml-auto mr-auto">
                        <span id="minutes"></span><span>:</span><span id="seconds"></span>
                    </p>
                </div>
            </div>
            <div className="row userheight align-items-center">
                <div className="col-12 text-center">
                    <i class="fas fa-microphone-slash options mr-5"></i>
                    <i class="fas fa-pause options mr-5"></i>
                    <i class="fas fa-volume-up options"></i>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <button onClick={handleClose}>
                        <i className="fas fa-phone-square text-danger callicon"></i>
                    </button>
                </div>
            </div>
        </div>

    )
}


export default Callcancel;